import { createBrowserRouter } from 'react-router-dom';
import Root from './Root';
import Home from './Home';
import Terms from './Terms';
import Prices from './Prices';
import Contact from './Contact';
import Request from './Request';
import Clients from './Clients';

export const routes = [
  {
    name: 'Home',
    path: '/',
    element: <Home />,
  },
  {
    name: 'Terms',
    path: '/terms',
    element: <Terms />,
  },
  {
    name: 'Prices',
    path: '/prices',
    element: <Prices />,
  },
  {
    name: 'Contact',
    path: '/contact',
    element: <Contact />,
  },
  {
    name: 'Request',
    path: '/request',
    element: <Request />,
  },
  {
    name: 'Clients',
    path: '/clients',
    element: <Clients />
  }
];

export const router = createBrowserRouter(routes);

export { Root };
